import axios from '../../utils/axios';

export const invoicesApi = {
  createInvoice: (invoiceData) => {
    const formData = new FormData();
    Object.keys(invoiceData).forEach(key => {
      if (key === 'files') {
        invoiceData[key].forEach(file => {
          formData.append('files', file);
        });
      } else {
        formData.append(key, invoiceData[key]);
      }
    });
    
    return axios.post('/invoices/create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  
  getUserInvoices: (url) => {
    return axios.get(url);
  },

  getInvoiceDetails: (invoiceId) => {
    return axios.get(`/invoices/invoice/${invoiceId}`);
  },

  createAdminInvoice: (invoiceData) => {
    const formData = new FormData();
    Object.keys(invoiceData).forEach(key => {
      if (key === 'files') {
        invoiceData[key].forEach(file => {
          formData.append('files', file);
        });
      } else {
        formData.append(key, invoiceData[key]);
      }
    });
    
    return axios.post('/admin/create-invoice', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  getAllInvoices: (url) => {
    return axios.get(url);
  },

  getAdminInvoiceDetails: (invoiceId) => {
    return axios.get(`/admin/invoice/${invoiceId}`);
  },

  updateInvoiceStatus: (invoiceId, data) => {
    return axios.patch(`/admin/invoice/${invoiceId}`, data);
  },

  updateInvoiceTerms: (invoiceId, data) => {
    return axios.patch(`/admin/invoice/${invoiceId}`, data);
  },

  uploadAdditionalDocuments: (invoiceId, documents) => {
    return axios.post(`/invoices/upload-documents/${invoiceId}`, documents, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  createDraftInvoice: (invoiceData) => {
    return axios.post('/invoices/create-draft', invoiceData);
  },

  createAdminDraftInvoice: (invoiceData) => {
    return axios.post('/admin/create-draft', invoiceData);
  },

  getUserDraftInvoices: () => {
    return axios.get('/invoices/drafts?limit=0&page=1');
  },

  getAdminDraftInvoices: (page = 1, limit = 0) => {
    return axios.get(`/admin/all-draft-invoices?limit=${limit}&page=${page}`);
  },

  getAllFundedInvoices: (page = 1, limit = 0, searchTerm = '') => {
    return axios.get(`/admin/all-funded-invoices?limit=${limit}&page=${page}&search=${searchTerm}`);
  },

  attachInvoicePayment: (invoiceId, paymentData) => {
    return axios.post(`/admin/invoice/${invoiceId}/payment`, paymentData);
  },

  updateUserInvoiceStatus: (invoiceId, data) => {
    return axios.patch(`/invoices/invoice/${invoiceId}`, data);
  },

  addInvoiceCharges: (invoiceId, chargesData) => {
    return axios.post(`/admin/invoice/${invoiceId}/late-charge`, chargesData);
  },

  updateInvoicePayment: (paymentId, paymentData) => {
    return axios.patch(`/admin/invoice/payment/${paymentId}`, paymentData);
  },

  deleteInvoicePayment: (paymentId) => {
    return axios.delete(`/admin/invoice/payment/${paymentId}`);
  },

  updateInvoiceCharge: (chargeId, chargeData) => {
    return axios.patch(`/admin/invoice/late-charge/${chargeId}`, chargeData);
  },
  
  deleteInvoiceCharge: (chargeId) => {
    return axios.delete(`/admin/invoice/late-charge/${chargeId}`);
  }
};
